import { routeMap } from '../Routes';
import { ModuleParamLists, RootScreensParamLists } from '../typings/Params';


function interpolate(
    path: string,
    params?: Record<string, unknown>,
) {
    if (!params) {
        return path.replace(/\/:[^/]+\?/g, '');
    }

    return path
        .replace(/:([A-Za-z0-9_]+)\?/g, (_, key) => {
            const value = params[key];

            return value == null
                ? ''
                : encodeURIComponent(String(value));
        })
        .replace(/:([A-Za-z0-9_]+)/g, (_, key) => {
            const value = params[key];

            if (value == null) {
                throw new Error(`Missing route param "${key}"`);
            }

            return encodeURIComponent(String(value));
        })
        .replace(/\/+/g, '/');
}

export function openInNewTab<
    P extends keyof RootScreensParamLists,
>(
    page: P,
    params?: RootScreensParamLists[P],
): void;

export function openInNewTab<
    M extends keyof ModuleParamLists,
    S extends keyof ModuleParamLists[M],
>(
    module: M,
    options: {
        screen: S;
        params?: ModuleParamLists[M][S];
    },
): void;


// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function openInNewTab(...args: any[]) {
    let path: string;
    let params: Record<string, unknown> | undefined;

    if (args.length === 1 || !('screen' in (args[1] ?? {}))) {
        const route = routeMap.get(args[0]);

        if (!route) {
            throw new Error(`Unknown route "${args[0]}"`);
        }

        path = route.path;
        params = args[1];
    } else {
        const { screen, params: screenParams } = args[1];

        const route = routeMap.get(screen);

        if (!route) {
            throw new Error(`Unknown route "${String(screen)}"`);
        }

        path = route.path;
        params = screenParams;
    }

    // eslint-disable-next-line no-restricted-properties
    window.open(interpolate(path, params), '_blank');
}

export function openExternalLinkInNewTab(link: string) {
    // eslint-disable-next-line no-restricted-properties
    window.open(link, '_blank');
}

export function forceRedirectToLogin() {
    // eslint-disable-next-line no-restricted-syntax
    window.location.href = '/login';
}
